import React from "react"
import { Container, Row, Col } from "reactstrap"
import CookieSettingsLink from "../Common/CookieSettingsLink"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Tokenized Green.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                <CookieSettingsLink className="text-muted" />
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
